import {  BackupTable, CurrencyExchange, DeliveryDining,  Download,  ExpandLess, ExpandMore, FireTruck, Home, InputOutlined, ListAltOutlined, ListOutlined, ListTwoTone, MonetizationOn, Person2, Sell, ShoppingCart, VerifiedUser } from "@mui/icons-material";
import { Box, Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import React, { useContext } from "react";
import { createBrowserRouter, Navigate,  RouterProvider } from "react-router-dom";
import { AdminTemplate } from "../components/plataforma/admin-template";
import { AppContext } from "../store/AppStore";
import {  Perfiles } from "../utils/constants";
import { Login } from "../views/login";
import { Main } from "../views/main";
import { MaestroCentrosOperacion } from "../views/plataforma/maestro-centros-operacion";
import { MaestroProductos } from "../views/plataforma/maestro-productos";
import { MaestroProveedores } from "../views/plataforma/maestro-proveedores";
import { MaestroSobreCosto } from "../views/plataforma/maestro-sobre-costos";
import { MaestroTiposVehiculos } from "../views/plataforma/maestro-tipos-vehiculos";
import { MaestroUnidadesMedidas } from "../views/plataforma/maestro-unidades-medidas";
import { MaestrosUsuarios } from "../views/plataforma/maestro-usuarios";
import { Necesidades } from "../views/plataforma/necesidades";
import AssignmentIcon from '@mui/icons-material/Assignment';
import { ComprasProductos } from "../views/plataforma/compras-productos";
import { MaestrosClasificacionClientes } from "../views/plataforma/marketplace/maestro-clasificacion-clientes";
import { MaestroClientes } from "../views/plataforma/marketplace/maestro-clientes";
import { MaestroOfertas } from "../views/plataforma/marketplace/maestro-ofertas";
import { NecesidadesExternas } from "../views/plataforma/necesidades-externas";
import { MaestrosPedidos } from "../views/plataforma/marketplace/maestro-pedidos";
import { MaestrosGerarquiaCompradores } from "../views/plataforma/maestro-jerarquia-compradores";
import { MisProductosAsociados } from "../views/plataforma/mis-productos-asociados";
import { MaestroSobreCostoBodegas } from "../views/plataforma/maestro-sobre-costos-bodegas";
import { MisCotizaciones } from "../views/plataforma/mis-cotizaciones";
import { MaestrosProcesos } from "../views/plataforma/maestro-log-procesos";
import { MaestroCategorias } from "../views/plataforma/marketplace/maestro-categorias";
import { MaestroProductosVentas } from "../views/plataforma/marketplace/maestro-productos-ventas";
import { MaestrosProoveedoresLogisticos } from "../views/plataforma/logistico/maestro-proveedores-logisticos";

import TabProgramacion from "../views/plataforma/logistico/programacion-recogidas/tab-programacion";
import { SolicitudTransporte } from "../views/solicitud-transporte";
import { RutaLogistica } from "../views/ruta-logistica";
import { MisCompras } from "../views/plataforma/mis-compras/mis-compras";
import { CrudFirma } from "../views/crud-firma";
import TabCompras from "../views/plataforma/mis-compras/tab-compras";
import { AgentesProveedores } from "../views/plataforma/agentes-proveedores";
import { AgentesNecesidadesList } from "../views/plataforma/agentes-necesidades-list";
import { AgentesCotizacionesList } from "../views/plataforma/agentes-cotizaciones-list";
import { AgentesComprasProveedorList } from "../views/plataforma/agentes-compras-por-proveedor-list";
import { ReciboListadoOrdenes } from "../views/plataforma/recibo/listado-ordenes";
import { DetalleReciboOrden } from "../views/plataforma/recibo/detalle-recibo-orden";
import { MaestroPlanosProcesos } from "../views/plataforma/maestro-planos-procesos";
import { FichaTecnica } from "../views/ficha_tecnica";
import { MaestrosTiposEntrega } from "../views/plataforma/marketplace/maestro-tipos-entregas";
import { MiPerfil } from "../views/plataforma/mi-perfil";
import { MaestroCompanias } from "../views/plataforma/maestro-companias";
import { MaestroMediosPagos } from "../views/plataforma/marketplace/maestro-medios-pagos";
import { MaestrosCondicionesPagos } from "../views/plataforma/maestro-condiciones-pagos";
import { GestionGeneralCompras } from "../views/plataforma/auditoria-compras/gestion-general-compras";
import TabAuditoriaCompras from "../views/plataforma/auditoria-compras/tab-auditoria-compras";
import { MaestroServiciosUltimaMilla } from "../views/plataforma/marketplace/maestro-servicios-ultima-milla";
import { AlistamientoInit } from "../views/plataforma/alistador/alistamiento-init";
import { DetalleAlistamiento } from "../views/plataforma/alistador/detalle-alistamiento";
import { MaestroDocumentos } from "../views/plataforma/logistico/maestro-documentos";
import { MisSubastas } from "../views/plataforma/mis-subastas";
import { SalaSubastaPage } from "../features/subasta-inversa-live";


export const AppERoutesIndex = {
  main:"/",
 login:"/login",
 generarFirma:"/generar-firma",
 solicitudTransporte:"/solicitud-de-transporte/:token",
 rutaLogistica:"/ruta-logistica/:token",
 fichaTecnica:"/ficha-tecnica/:cod_producto/:cod_usuario",
 plataformaBase:"/plataforma",
 MiPerfil:"/plataforma/mi-perfil",
 maestrosProductos:"/plataforma/maestros-productos",
 misProductosAsciados:"/plataforma/mis-productos-asociados",
 maestrosUnidadesMedidas:"/plataforma/maestros-unidades-medidas",
 maestrosProveedores:"/plataforma/maestros-proveedores",
 maestrosTipoVehiculo:"/plataforma/maestros-tipo-vehiculos",
 maestrosSobreCostos:"/plataforma/maestros-sobre-costo",
 maestrosSobreCostosBodegas:"/plataforma/maestros-sobre-costo-bodegas",
 maestrosCentrosOperacion:"/plataforma/maestros-centros-operacion",
 maestrosUsuarios:"/plataforma/maestros-usuarios",
 maestrosCompanias:"/plataforma/maestros-companias",
 maestrosConfigComprador:"/plataforma/maestros-cofig-compradores",
 maestrosProcesos:"/plataforma/maestros-procesos",
 necesidades:"/plataforma/necesidades",
 misCotizaciones:"/plataforma/mis-cotizaciones",
 necesidadesInternas:"/plataforma/necesidades/internas",
 necesidadesExternas:"/plataforma/necesidades/externas",
 comprasProductos:"/plataforma/compras-por-producto/:cod_producto/:fecha_entrega/:cod_unidad_medida",
 clasificacionClientes:"/plataforma/maestros-market-place/clasificacion_clientes",
 maestrosPedidos:"/plataforma/maestros-market-place/pedidos",
 listadoClientes:"/plataforma/maestros-market-place/lista_clientes",
 ListasPrecios:"/plataforma/maestros-market-place/listas_precios",
 Categorias:"/plataforma/maestros-market-place/categorias",
 productosVentas:"/plataforma/maestros-market-place/productos-ventas",
 Ofertas:"/plataforma/maestros-market-place/ofertas",
 TiposEntrega:"/plataforma/maestros-market-place/tipos-entrega",
 MediosPagos:"/plataforma/maestros-market-place/medios-pagos",
 CondicionesPagos:"/plataforma/maestros-market-place/condiciones-pagos",
 ServiciosUltimaMilla:"/plataforma/maestros-market-place/servicios-ultima-milla",
 programacionRecogidas:"/plataforma/programacion-recogidas",
 ProveedoresLogisticos:"/plataforma/proveedores-logisticos",
 MaestroProveedoresLogisticos:"/plataforma/proveedores-logisticos/maestro-proveedores-logisticos",
 MaestroAgentesProveedores:"/plataforma/agentes-proveedores",
 MaestroAgentesNecesidades:"/plataforma/agentes-necesidades",
 MaestroAgentesCotizaciones:"/plataforma/agentes-cotizaciones",
MaestroSubastas:"/plataforma/subastas",
 ComprasAgentes:"/plataforma/compras-agentes",
 ReciboListadoOrdenes:"/plataforma/recibo/listado-ordenes",
 ReciboDetalleListadoOrdenes:"/plataforma/recibo/:cod_erp_orden",
 MisCompras:"/plataforma/mis-compras",
 MaestroPlanos:"/plataforma/maestro-planos",
 GestionCompras:"/plataforma/gestion-general-compras",
 GestionVentas:"/plataforma/gestion-general-ventas",
 AlistamientoInit:"/plataforma/alistamiento",
 MaestroDocumentos:"/plataforma/maestro-documentos",
 DetalleAlistamiento:"/plataforma/detalle-alistamiento/:cod_pedido",
 MisSubastas:"/plataforma/mis-subastas",
 SalaSubasta:"/plataforma/subastas/sala/:cod",
 NotFoundRoute:"*"
 
};




export const routesConfig = [
    {
        path:AppERoutesIndex.main,
        element:<Main />,
        allowedRoles:["*"]
    },
    {
        path:AppERoutesIndex.login,
        element:<Login />,
        allowedRoles:["*"]
    },
    {
        path:AppERoutesIndex.generarFirma,
        element:<CrudFirma />,
        allowedRoles:["*"]
    },
    {
        path:AppERoutesIndex.solicitudTransporte,
        element:<SolicitudTransporte />,
        allowedRoles:["*"]
    },
    {
        path:AppERoutesIndex.rutaLogistica,
        element:<RutaLogistica />,
        allowedRoles:["*"]
    },
    {
        path:AppERoutesIndex.fichaTecnica,
        element:<FichaTecnica />,
        allowedRoles:["*"]
    },
    {
        path:AppERoutesIndex.plataformaBase,
        element:<AdminTemplate />,
        allowedRoles:["*"],
        children:[

            {
                path:AppERoutesIndex.MaestroDocumentos,
                element:<MaestroDocumentos />,
                allowedRoles:[Perfiles.administrador,Perfiles.logistico]
            },
            {
                path:AppERoutesIndex.AlistamientoInit,
                element:<AlistamientoInit />,
                allowedRoles:[Perfiles.administrador,Perfiles.alistador]
            },
            {
                path:AppERoutesIndex.DetalleAlistamiento,
                element:<DetalleAlistamiento  />,
                allowedRoles:[Perfiles.administrador,Perfiles.alistador]
            },
            {
                path:AppERoutesIndex.maestrosCompanias,
                element:<MaestroCompanias />,
                allowedRoles:[Perfiles.administrador]
            },
            {
                
                path:AppERoutesIndex.maestrosProcesos,
                element:<MaestrosProcesos />,
                allowedRoles:[Perfiles.administrador]
            },
            {
                path:AppERoutesIndex.MaestroPlanos,
                element:<MaestroPlanosProcesos />,
                allowedRoles:[Perfiles["exportador-plano"],Perfiles.administrador]
            },
           {
            path:AppERoutesIndex.maestrosProductos,
            element:<MaestroProductos />,
            allowedRoles:[Perfiles.administrador,Perfiles.recibidor,Perfiles["lider-ventas"],Perfiles["administrador-punto-venta"]]
           },
           {
            path:AppERoutesIndex.MediosPagos,
            element:<MaestroMediosPagos />,
            allowedRoles:[Perfiles.administrador,Perfiles["administrador-punto-venta"]]
           },
           {
            path:AppERoutesIndex.CondicionesPagos,
            element:<MaestrosCondicionesPagos />,
            allowedRoles:[Perfiles.administrador,Perfiles["administrador-punto-venta"]]
           },
           {
            path:AppERoutesIndex.maestrosProveedores,
            element:<MaestroProveedores />,
            allowedRoles:[Perfiles.administrador]
           },
           {
            path:AppERoutesIndex.maestrosUnidadesMedidas,
            element:<MaestroUnidadesMedidas />,
            allowedRoles:[Perfiles.administrador]
           },
           {
            path:AppERoutesIndex.maestrosTipoVehiculo,
            element:<MaestroTiposVehiculos />,
            allowedRoles:[Perfiles.administrador,Perfiles.logistico]
           },
           {
            path:AppERoutesIndex.maestrosSobreCostos,
            element:<MaestroSobreCosto />,
            allowedRoles:[Perfiles.administrador,]
           },
           {
            path:AppERoutesIndex.maestrosCentrosOperacion,
            element:<MaestroCentrosOperacion />,
            allowedRoles:[Perfiles.administrador,Perfiles.logistico,Perfiles["administrador-punto-venta"]]
           },
           {
            path:AppERoutesIndex.maestrosUsuarios,
            element:<MaestrosUsuarios />,
            allowedRoles:[Perfiles.administrador,Perfiles.logistico]
           },
           {
            path:AppERoutesIndex.maestrosSobreCostosBodegas,
            element:<MaestroSobreCostoBodegas />,
            allowedRoles:[Perfiles.administrador,Perfiles.logistico]
           },
           {
            path:AppERoutesIndex.MisCompras,
            element:<TabCompras />,
            allowedRoles:[Perfiles.administrador,Perfiles.comprador]
           },
       
        {
            path:AppERoutesIndex.comprasProductos,
            element:<ComprasProductos />,
            allowedRoles:[Perfiles.administrador,Perfiles.comprador,Perfiles.comprador_acercate]
        },
        {
            path:AppERoutesIndex.clasificacionClientes,
            element:<MaestrosClasificacionClientes />,
            allowedRoles:[Perfiles.administrador,Perfiles["lider-ventas"],Perfiles["administrador-punto-venta"]]
        },
        {
            path:AppERoutesIndex.listadoClientes,
            element:<MaestroClientes />,
            allowedRoles:[Perfiles.administrador,Perfiles["lider-ventas"],Perfiles["administrador-punto-venta"]]
        },
        {
            path:AppERoutesIndex.Ofertas,
            element:<MaestroOfertas />,
            allowedRoles:[Perfiles.administrador,Perfiles["lider-ventas"],Perfiles["administrador-punto-venta"]]
        },
        {
            path:AppERoutesIndex.necesidadesInternas,
            element:<Necesidades/>,
            allowedRoles:[Perfiles.administrador,Perfiles.comprador,Perfiles.comprador_acercate]
        },
        {
            path:AppERoutesIndex.necesidadesExternas,
            element:<NecesidadesExternas />,
            allowedRoles:[Perfiles.administrador,Perfiles.comprador,Perfiles.comprador_acercate]
        },
        {
            path:AppERoutesIndex.maestrosPedidos,
            element:<MaestrosPedidos />,
            allowedRoles:[Perfiles.administrador,Perfiles.vendedor,Perfiles["lider-ventas"],Perfiles["administrador-punto-venta"]]
        },
        {
            path:AppERoutesIndex.maestrosConfigComprador,
            element:<MaestrosGerarquiaCompradores />,
            allowedRoles:[Perfiles.administrador]
        },
        {
            path:AppERoutesIndex.misProductosAsciados,
            element:<MisProductosAsociados />,
            allowedRoles:[Perfiles.administrador,Perfiles.comprador,Perfiles.comprador_acercate]
        },
        {
            path:AppERoutesIndex.misCotizaciones,
            element:<MisCotizaciones />,
            allowedRoles:[Perfiles.administrador,Perfiles.comprador,Perfiles.comprador_acercate]
        },
                {
            path:AppERoutesIndex.MaestroSubastas,
            element:<MisSubastas />,
            allowedRoles:[Perfiles.administrador,Perfiles.comprador,Perfiles.comprador_acercate]
        },
        {
            path:AppERoutesIndex.Categorias,
            element:<MaestroCategorias />,
            allowedRoles:[Perfiles.administrador,Perfiles["lider-ventas"],Perfiles["administrador-punto-venta"]]
        },
        {
            path:AppERoutesIndex.TiposEntrega,
            element:<MaestrosTiposEntrega />,
            allowedRoles:[Perfiles.administrador,Perfiles["lider-ventas"],Perfiles["administrador-punto-venta"]]
        },
        {
            path:AppERoutesIndex.productosVentas,
            element:<MaestroProductosVentas />,
            allowedRoles:[Perfiles.administrador,Perfiles["lider-ventas"],Perfiles["administrador-punto-venta"]]
        },
        {
            path:AppERoutesIndex.ServiciosUltimaMilla,
            element:<MaestroServiciosUltimaMilla />,
            allowedRoles:[Perfiles.administrador,Perfiles["lider-ventas"]]
        },
        {
            path:AppERoutesIndex.programacionRecogidas,
            element:<TabProgramacion />,
            allowedRoles:[Perfiles.logistico,Perfiles.administrador]
        },
       {
            path:AppERoutesIndex.MaestroProveedoresLogisticos,
            element:<MaestrosProoveedoresLogisticos />,
            allowedRoles:[Perfiles.logistico,Perfiles.administrador]
        },
        {
            path:AppERoutesIndex.MaestroAgentesProveedores,
            element:<AgentesProveedores />,
            allowedRoles:[Perfiles["agente-regional"],Perfiles.administrador]
        },
        {
            path:AppERoutesIndex.MaestroAgentesNecesidades,
            element:<AgentesNecesidadesList />,
            allowedRoles:[Perfiles["agente-regional"],Perfiles.administrador]
        },
        {
            path:AppERoutesIndex.MaestroAgentesCotizaciones,
            element:<AgentesCotizacionesList />,
            allowedRoles:[Perfiles["agente-regional"],Perfiles.administrador]
        },
        {
            path:AppERoutesIndex.ComprasAgentes,
            element:<AgentesComprasProveedorList />,
            allowedRoles:[Perfiles["agente-regional"],Perfiles.administrador]
        },
        {
            path:AppERoutesIndex.ReciboListadoOrdenes,
            element:<ReciboListadoOrdenes />,
            allowedRoles:[Perfiles.recibidor,Perfiles.administrador]
        },
        {
            path:AppERoutesIndex.ReciboDetalleListadoOrdenes,
            element:<DetalleReciboOrden />,
            allowedRoles:[Perfiles.recibidor,Perfiles.administrador]
        },
        {
            path:AppERoutesIndex.GestionCompras,
            element:<TabAuditoriaCompras />,
            allowedRoles:[Perfiles.administrador]
        },
        {
            path:AppERoutesIndex.MiPerfil,
            element:<MiPerfil />,
            allowedRoles:["*"]
        },
        {
            path:AppERoutesIndex.MisSubastas,
            element:<MisSubastas />,
            allowedRoles:[Perfiles.administrador,Perfiles.comprador,Perfiles.comprador_acercate]
        },
        {
            path:AppERoutesIndex.SalaSubasta,
            element:<SalaSubastaPage />,
            allowedRoles:[Perfiles.administrador,Perfiles.comprador,Perfiles.comprador_acercate]
        },
      
           
        ],

    },
   
   
     {
            path:AppERoutesIndex.NotFoundRoute,
            element:<Navigate to={AppERoutesIndex.login}  />,
            allowedRoles:["*"]
        },
];

const MenuItemCustom = ({action,label,icon,subItems,keyItem,currentPath='',drawerOpen=true})=>{

  
     const [opened,setOpened] = React.useState(false);
     const isSelected = currentPath === keyItem || (subItems || []).some((subItem) => subItem.key === currentPath);

    return (<>
    <ListItem onClick={ subItems.length > 0? ()=> setOpened(!opened): ()=>action(keyItem)} key={keyItem} disablePadding>
    <ListItemButton selected={isSelected} aria-current={isSelected ? 'page' : undefined}>
      <ListItemIcon>
        {icon}
      </ListItemIcon>
      <ListItemText primary={label} />
      {drawerOpen && !!subItems && subItems.length > 0? (opened ? <ExpandLess /> : <ExpandMore />):null }  
    </ListItemButton>
  </ListItem>
    { 
         <Collapse in={drawerOpen && opened} timeout="auto" unmountOnExit>
         <List component="div" disablePadding>
           {
            subItems.map( subItem=><ListItemButton selected={currentPath === subItem.key} onClick={()=>action(subItem.key)} key={subItem.key} sx={{ pl: 4 }}>
                <ListItemIcon key={subItem.key} >
                    {subItem.icon}
                </ListItemIcon>
                <ListItemText primary={subItem.label} />
              </ListItemButton> )
           }
         </List>
       </Collapse> 
    }
    </>);

}

const MenuItems = [
    {
        key:AppERoutesIndex.plataformaBase,
        label:"Inicio",
        icon:<Home />,
        allowedRoles:["*"],
        subItems:[],
        element:MenuItemCustom
    },
    {
        key:AppERoutesIndex.plataformaBase+"-Maestros",
        label:"Maestros",
        icon:<BackupTable />,
        allowedRoles:[Perfiles.logistico,Perfiles.administrador,Perfiles.recibidor,Perfiles["lider-ventas"],Perfiles["administrador-punto-venta"]],
        element:MenuItemCustom,
        subItems:[
            {
                key:AppERoutesIndex.MaestroDocumentos,
                label:"Descargas",
                icon:<></>,
                allowedRoles:[Perfiles.administrador,Perfiles.logistico],
                element:MenuItemCustom
            },
            {
                key:AppERoutesIndex.maestrosCompanias,
                label:"Compañias",
                icon:<></>,
                allowedRoles:[Perfiles.administrador],
                element:MenuItemCustom
            },
            ,{
                key:AppERoutesIndex.CondicionesPagos,
                label:"Condiciones de pagos",
                icon:<></>,
                allowedRoles:[Perfiles.administrador,Perfiles["administrador-punto-venta"]],
                element:MenuItemCustom
            },
            ,{
            key:AppERoutesIndex.maestrosProductos,
            label:"productos",
            icon:<></>,
            allowedRoles:[Perfiles.administrador,Perfiles.recibidor,Perfiles["lider-ventas"],Perfiles["administrador-punto-venta"]],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.maestrosProcesos,
            label:"Procesos",
            icon:<></>,
            allowedRoles:[Perfiles.administrador],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.maestrosProveedores,
            label:"proveedores",
            icon:<></>,
            allowedRoles:[Perfiles.administrador],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.maestrosUnidadesMedidas,
            label:"Unidades de medida",
            icon:<></>,
            allowedRoles:[Perfiles.administrador],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.maestrosTipoVehiculo,
            label:"Tipo de vehiculo",
            icon:<></>,
            allowedRoles:[Perfiles.administrador,Perfiles.logistico],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.maestrosCentrosOperacion,
            label:"Centros de operacion",
            icon:<></>,
            allowedRoles:[Perfiles.administrador,Perfiles.logistico,Perfiles["administrador-punto-venta"]],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.maestrosSobreCostos,
            label:"Rutas",
            icon:<></>,
            allowedRoles:[Perfiles.administrador,Perfiles.logistico],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.maestrosSobreCostosBodegas,
            label:"Sobrecostos bodegas",
            icon:<></>,
            allowedRoles:[Perfiles.administrador,Perfiles.logistico],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.maestrosUsuarios,
            label:"Usuarios",
            icon:<></>,
            allowedRoles:[Perfiles.administrador],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.maestrosConfigComprador,
            label:"Config. compradores",
            icon:<></>,
            allowedRoles:[Perfiles.administrador],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.MaestroProveedoresLogisticos,
            label:"Proveedores logisticos",
            icon:<></>,
            allowedRoles:[Perfiles.logistico,Perfiles.administrador],
            element:MenuItemCustom
        },
       
        
    ],
    
       
    },
    {
        key:AppERoutesIndex.necesidades+"-All",
        label:"Necesidades",
        icon:<AssignmentIcon />,
        allowedRoles:[Perfiles.administrador,Perfiles.comprador,Perfiles.comprador_acercate],
        element:MenuItemCustom,
        subItems:[{
            key:AppERoutesIndex.necesidadesInternas,
            label:"Propias",
            icon:<></>,
            allowedRoles:[Perfiles.administrador,Perfiles.comprador,Perfiles.comprador_acercate],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.necesidadesExternas,
            label:"Terceros",
            icon:<></>,
            allowedRoles:[Perfiles.administrador,Perfiles.comprador,Perfiles.comprador_acercate],
            element:MenuItemCustom
        }
    ]
    },
    {
        key:AppERoutesIndex.misCotizaciones,
        label:"Cotizaciones",
        icon:<ListTwoTone />,
        allowedRoles:[Perfiles.administrador,Perfiles.comprador,Perfiles.comprador_acercate],
        subItems:[],
        element:MenuItemCustom
    },
    {
        key:AppERoutesIndex.MaestroSubastas,
        label:"Subastas",
        icon:<CurrencyExchange />,
        allowedRoles:[Perfiles.administrador,Perfiles.comprador,Perfiles.comprador_acercate],
        element:MenuItemCustom,
        subItems:[]
    },
    {
        key:AppERoutesIndex.plataformaBase+"-Maestros-clientes",
        label:"Marketplace",
        icon:<Sell />,
        allowedRoles:[Perfiles.administrador,Perfiles.vendedor,Perfiles["lider-ventas"],Perfiles["administrador-punto-venta"]],
        element:MenuItemCustom,
        subItems:[{
            key:AppERoutesIndex.MediosPagos,
            label:"Medios de pagos",
            icon:<></>,
            allowedRoles:[Perfiles.administrador,Perfiles["administrador-punto-venta"]],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.clasificacionClientes,
            label:"Clasificacion clientes",
            icon:<></>,
            allowedRoles:[Perfiles.administrador,Perfiles["administrador-punto-venta"]],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.listadoClientes,
            label:"Listado de clientes",
            icon:<></>,
            allowedRoles:[Perfiles.administrador,Perfiles["lider-ventas"],Perfiles["administrador-punto-venta"]],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.ServiciosUltimaMilla,
            label:"Servicio ultima milla",
            icon:<></>,
            allowedRoles:[Perfiles.administrador,Perfiles["lider-ventas"]],
            element:MenuItemCustom
        }, 
        {
            key:AppERoutesIndex.Ofertas,
            label:"Ofertas",
            icon:<></>,
            allowedRoles:[Perfiles.administrador,Perfiles["lider-ventas"],Perfiles["administrador-punto-venta"]],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.maestrosPedidos,
            label:"Pedidos",
            icon:<></>,
            allowedRoles:[Perfiles.administrador,Perfiles.vendedor,Perfiles["lider-ventas"],Perfiles["administrador-punto-venta"]],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.Categorias,
            label:"Categorias",
            icon:<></>,
            allowedRoles:[Perfiles.administrador,Perfiles["lider-ventas"],Perfiles["administrador-punto-venta"]],
            element:MenuItemCustom
        },
        {
            key:AppERoutesIndex.productosVentas,
            label:"Productos ventas",
            icon:<></>,
            allowedRoles:[Perfiles.administrador,Perfiles["lider-ventas"],Perfiles["administrador-punto-venta"]],
            element:MenuItemCustom
        }

    ]
    },
    {
        key:AppERoutesIndex.MisCompras,
        label:"Mis Compras",
        icon:<ShoppingCart />,
        subItems:[],
        allowedRoles:[Perfiles.administrador,Perfiles.comprador],
        element:MenuItemCustom
    },
    {
        key:"auditoria-All",
        label:"Auditoria",
        icon:<AssignmentIcon />,
        allowedRoles:[Perfiles["administrador-punto-venta"],Perfiles.administrador],
        element:MenuItemCustom,
        subItems:[
            {
                key:AppERoutesIndex.GestionCompras,
                label:"Compras",  
                icon:<></>,
                allowedRoles:[Perfiles.administrador],
                element:MenuItemCustom
            },
          /*   {
                key:AppERoutesIndex.necesidadesExternas,
                label:"Ventas",
                icon:<></>,
                allowedRoles:[Perfiles.administrador,Perfiles.comprador,Perfiles.comprador_acercate],
                element:MenuItemCustom
            } */
    ]
    },
    {
        key:"alistamiento-All",
        label:"Alistamiento",
        icon:<AssignmentIcon />,
        allowedRoles:[Perfiles.alistador,Perfiles.administrador],
        element:MenuItemCustom,
        subItems:[
            {
                key:AppERoutesIndex.AlistamientoInit,
                label:"General",  
                icon:<></>,
                allowedRoles:[Perfiles.administrador,Perfiles.alistador],
                element:MenuItemCustom
            },
          /*   {
                key:AppERoutesIndex.necesidadesExternas,
                label:"Ventas",
                icon:<></>,
                allowedRoles:[Perfiles.administrador,Perfiles.comprador,Perfiles.comprador_acercate],
                element:MenuItemCustom
            } */
    ]
    },
   
    {
        key:AppERoutesIndex.misProductosAsciados,
        label:"Mis productos asociados",
        icon:<ListAltOutlined />,
        allowedRoles:[Perfiles.administrador,Perfiles.comprador,Perfiles.comprador_acercate],
        subItems:[],
        element:MenuItemCustom
    },
    {
        key:AppERoutesIndex.programacionRecogidas,
        label:"Transporte de mercancia",
        icon:<DeliveryDining />,
        allowedRoles:[Perfiles.administrador,Perfiles.logistico],
        subItems:[],
        element:MenuItemCustom
    },
    {
        key:AppERoutesIndex.MaestroProveedoresLogisticos,
        label:"Proveedores logisticos",
        icon:<FireTruck />,
        allowedRoles:[Perfiles.administrador,Perfiles.logistico],
        element:MenuItemCustom,
        subItems:[]
    },
    {
        key:AppERoutesIndex.MaestroAgentesProveedores,
        label:"Proveedores asignados",
        icon:<ListOutlined />,
        allowedRoles:[Perfiles.administrador,Perfiles["agente-regional"]],
        element:MenuItemCustom,
        subItems:[]
    },
    {
        key:AppERoutesIndex.MaestroAgentesNecesidades,
        label:"Necesidades",
        icon:<ListOutlined />,
        allowedRoles:[Perfiles.administrador,Perfiles["agente-regional"]],
        element:MenuItemCustom,
        subItems:[]
    },
    {
        key:AppERoutesIndex.MaestroAgentesCotizaciones,
        label:"Agentes Cotizaciones",
        icon:<ListOutlined />,
        allowedRoles:[Perfiles.administrador,Perfiles["agente-regional"]],
        element:MenuItemCustom,
        subItems:[]
    },
    {
        key:AppERoutesIndex.ComprasAgentes,
        label:"Resumen de compras",
        icon:<MonetizationOn />,
        allowedRoles:[Perfiles.administrador,Perfiles["agente-regional"]],
        element:MenuItemCustom,
        subItems:[]
    },
    {
        key:AppERoutesIndex.ReciboListadoOrdenes,
        label:"Recibo e Ingreso",
        icon:<InputOutlined />,
        allowedRoles:[Perfiles.recibidor,Perfiles.administrador],
        element:MenuItemCustom,
        subItems:[]
    },
    {
        key:AppERoutesIndex.MaestroPlanos,
        label:"Maestro de planos",
        icon:<InputOutlined />,
        allowedRoles:[Perfiles["exportador-plano"],Perfiles.administrador],
        element:MenuItemCustom,
        subItems:[]
    },
    {
        key:AppERoutesIndex.MaestroDocumentos,
        label:"Descargas",
        icon:<Download />,
        allowedRoles:[Perfiles.logistico,Perfiles.administrador],
        element:MenuItemCustom,
        subItems:[]
    },
    {
        key:AppERoutesIndex.MiPerfil,
        label:"Mi Perfil",
        icon:<Person2 />,
        allowedRoles:["*"],
        element:MenuItemCustom,
        subItems:[]
    },
   
    

];

const GenerateRoute = (role)=>{

   let routesConfiAllowd = [];
    if (!role){
       routesConfiAllowd = routesConfig.filter( route=>route.allowedRoles.length === 0 || route.allowedRoles.includes("*") );
    }else{
        routesConfiAllowd =  routesConfig.filter( route=>route.allowedRoles.includes(role) || route.allowedRoles.includes("*") );

        try{

            routesConfiAllowd.forEach((subRoute,index)=>{
                const subRoutes =   subRoute.children?.filter(  chld_route=>chld_route.allowedRoles.includes(role) || chld_route.allowedRoles.includes("*") );
                routesConfiAllowd[index].children = subRoutes || [];
            });  

        }catch(e){
            console.log("Error element",e.message);
        }
       

       
    }

    return createBrowserRouter(routesConfiAllowd);

}

 const GetMenuItems = (role)=>{
if (!role){
    return MenuItems;
}else{
    return MenuItems.filter( menuItem=>menuItem.allowedRoles.includes(role) || menuItem.allowedRoles.includes("*") )
    .map( ele=>({...ele,subItems:ele.subItems.filter(menuItem=>menuItem.allowedRoles.includes(role) || menuItem.allowedRoles.includes("*"))}) );

}

}
export {
    GetMenuItems,
    GenerateRoute
}
const RouteComponent = React.memo(({ cod_perfil }) => (
  <RouterProvider router={GenerateRoute(cod_perfil)} />
));

export default function CustomRouterProvider() {
  const { store: { profile } } = useContext(AppContext);
  return <RouteComponent cod_perfil={profile?.cod_perfil} />;
}